import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';

class ScrollHandler extends PureComponent {
    static propTypes = {
        /** Function to call on scroll or on resize with true/false if the component is in view or not */
        onLazyLoad: PropTypes.func,
        /**
         * How many pixels before content enters the viewport should the element start loading?
         * Increase this px amount to lazy load things in advance before they are visible - 500 might be a good number
         */
        threshold: PropTypes.number,
        /** If we want to stop observing after first intersect, for example for <Unveil> it only needs to happen once */
        unobserveAfterIntersect: PropTypes.bool
    };

    static defaultProps = {
        onLazyLoad: () => {},
        threshold: 0
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {
            threshold,
        } = this.props;

        this.observer = new IntersectionObserver(
            this.observeEntries,
            {
                rootMargin: `0px 0px ${threshold}px 0px`
            }
        );

        this.observer.observe(this.element);
    }

    componentWillUnmount() {
        this.observer.unobserve(this.element);
    }

    observeEntries = (entries) => {
        const {
            onLazyLoad,
            unobserveAfterIntersect
        } = this.props;

        entries.forEach((entry) => {
            onLazyLoad(entry.isIntersecting);
            if (entry.isIntersecting && unobserveAfterIntersect) {
                this.observer.unobserve(entry.target);
            }
        });
    }

    render() {
        const {
            children
        } = this.props;

        return (
            <div
                ref={(el) => {
                    this.element = el;
                }}
            >
                {children}
            </div>
        );
    }
}

export default ScrollHandler;
